import {
  DEFAULT_ROWS_PER_PAGE,
  DEFAULT_PAGINATION_PAGE,
  SEARCH_QUERY_PARAM } from '../modules/table'

export const constructEndpoint = (endpoint, queries, isLocal) => {
  if (isLocal && process.env.LOCAL_DEV_DATA_SOURCE === 'live') {
    return `http://localhost:8080${endpoint}?${queries}`
  } else if (isLocal) {
    // endpoint for mock data
    return `http://localhost:8080${endpoint}`
  } else {
    return `${endpoint}?${queries}`
  }
}

export const constructQueries = (state, pageType) => {
  const partners = state.authProfile ? state.authProfile.partners : []
  const userPartners = state.authProfile ? state.authProfile.userPartners : []
  const page = state.table ? state.table.paginationPage[pageType] : DEFAULT_PAGINATION_PAGE
  const limit = state.table ? state.table.paginationRowsPerPage[pageType] : DEFAULT_ROWS_PER_PAGE
  const searchQuery = state.table ? state.table.searchValues[pageType] : ''
  const queries = [`page=${page}`, `&limit=${limit}`]

  if(searchQuery) {
    const searchQueryParam = SEARCH_QUERY_PARAM[pageType]
    queries.push(`&${searchQueryParam}=${searchQuery}`)
  }

  if (searchQuery === '' && partners.length > 0 && userPartners.length > 0) {
    // partners user is admin for and basic user for
    const partnerIdString = createCSVFromArrayOfObjects([...partners, ...userPartners], 'id')
    queries.push(`&partnerIds=${partnerIdString}`)
  } else if (searchQuery === '' && partners.length > 0) {
    // partners user is admin for.
    const partnerIdString = createCSVFromArrayOfObjects(partners, 'id')
    queries.push(`&partnerIds=${partnerIdString}`)
  } else if (searchQuery === '' && userPartners.length > 0) {
    // partners user is only basic user for
    const partnerIdString = createCSVFromArrayOfObjects(userPartners, 'id')
    queries.push(`&partnerIds=${partnerIdString}`)
  }

  return queries
}

export const containsRole = (rolesArr, query) => {
  return rolesArr.some(role => role.name.toLowerCase().indexOf(query.toLowerCase()) >= 0)
}

export const createCSVFromArrayOfObjects = (array, paramName) => {
  let string = array && array.reduce((returnString, partnerObject, index, partnerArray) => {
    if (index !== partnerArray.length - 1) {
      return partnerObject[paramName] ? returnString + partnerObject[paramName] + ',' : returnString
    } else {
      return partnerObject[paramName] ? returnString + partnerObject[paramName] : returnString
    }
  },'')
  // remove trailing commas and spaces
  return string.replace(/,\s*$/, "");
}

export const getAdminTypeString = (userMemberships, userRoles) => {
  let results = 'unknown'

  if(userMemberships.includes('System-Admin')) {
    results = 'System-Admin'
  } else if(userMemberships.includes('Application-Admin')) {
    results = 'Application-Admin'
  } else if(userRoles.includes('PartnerAccessAdmin')) {
    results = 'PartnerAccessAdmin'
  }

  return results
}

export const getUserName = (userProfile) => {
  // If the user has a first name and lastname property, use that
  // if they don't user their name attribute and finally use either username or email
  let userName = 'this user'
  let user = userProfile ? userProfile.user : 'undefined'
  if (user && user.firstName && user.lastName) {
    userName = `${user.firstName} ${user.lastName}`
  } else if (user && user.name) {
    userName = user.name.split('@')[0]
  } else if (user && (user.username || user.email)) {
    userName = user.username || user.email
  } else if (userProfile && userProfile.name) {
    userName = userProfile.name.split('@')[0]
  }
  return userName
}

export const hasAuthorization = (userMemberships, userRoles, allowedMemberships, allowedRoles) => {
  // if the user has an allowed membership, immediately return true. If not, check for roles
  return hasMembership(userMemberships, allowedMemberships) || hasRole(userRoles, allowedRoles)
}

export const hasMembership = (userMemberships, allowedMemberships) => {
  return userMemberships && userMemberships.some(membership => allowedMemberships.includes(membership))
}

export const hasRole = (userRoles, allowedRoles) => {
  return userRoles && userRoles.some(role => allowedRoles.includes(role))
}

export const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false
    }
  }
  return true
}

export const parseQuery = (query) => {
  return query ? JSON.parse('{"' + decodeURI(query).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}') : {}
}

export const sorted = (items) => {
  return items.sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase())
}

export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
}
